/*why-this-error-occurred*/
/*solution*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "环境变量前缀无效",
  "description": "了解更多关于 Turborepo 中无效环境变量前缀的错误信息。"
};
export let structuredData = {
  "contents": [{
    "heading": "为什么会出现此错误-why-this-error-occurred",
    "content": "¥Why this error occurred"
  }, {
    "heading": "为什么会出现此错误-why-this-error-occurred",
    "content": "在 turbo.json 中声明环境变量时，不能在其前添加 $。这是一种用于声明对环境变量依赖的旧语法，在 Turborepo 1.5 中已弃用。"
  }, {
    "heading": "为什么会出现此错误-why-this-error-occurred",
    "content": "¥When declaring environment variables in your turbo.json, you cannot prefix them with $. This\nwas an old syntax for declaring a dependency on an environment variable that was deprecated in Turborepo 1.5."
  }, {
    "heading": "为什么会出现此错误-why-this-error-occurred",
    "content": "上面声明的环境变量带有 $ 前缀。"
  }, {
    "heading": "为什么会出现此错误-why-this-error-occurred",
    "content": "¥The environment variable declared above has the $ prefix."
  }, {
    "heading": "解决方案-solution",
    "content": "¥Solution"
  }, {
    "heading": "解决方案-solution",
    "content": "从环境变量声明中删除 $ 前缀。"
  }, {
    "heading": "解决方案-solution",
    "content": "¥Remove the $ prefix from your environment variable declaration."
  }, {
    "heading": "解决方案-solution",
    "content": "你可以使用 npx @turbo/codemod migrate-env-var-dependencies 迁移到 env 和 globalEnv 键。签出 codemod 文档（更多详情）。"
  }, {
    "heading": "解决方案-solution",
    "content": "¥You can migrate to the env and globalEnv keys using npx @turbo/codemod migrate-env-var-dependencies.\nCheck out the codemod's documentation for more details."
  }],
  "headings": [{
    "id": "为什么会出现此错误-why-this-error-occurred",
    "content": "为什么会出现此错误 /*why-this-error-occurred*/"
  }, {
    "id": "解决方案-solution",
    "content": "解决方案 /*solution*/"
  }]
};
export const toc = [{
  depth: 2,
  url: "#为什么会出现此错误-why-this-error-occurred",
  title: _jsx(_Fragment, {
    children: "为什么会出现此错误 "
  })
}, {
  depth: 2,
  url: "#解决方案-solution",
  title: _jsx(_Fragment, {
    children: "解决方案 "
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    p: "p",
    pre: "pre",
    span: "span",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      id: "为什么会出现此错误-why-this-error-occurred",
      children: "为什么会出现此错误 "
    }), "\n", _jsx(_components.p, {
      children: "¥Why this error occurred"
    }), "\n", _jsxs(_components.p, {
      children: ["在 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 中声明环境变量时，不能在其前添加 ", _jsx(_components.code, {
        children: "$"
      }), "。这是一种用于声明对环境变量依赖的旧语法，在 Turborepo 1.5 中已弃用。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥When declaring environment variables in your ", _jsx(_components.code, {
        children: "turbo.json"
      }), ", you cannot prefix them with ", _jsx(_components.code, {
        children: "$"
      }), ". This\nwas an old syntax for declaring a dependency on an environment variable that was deprecated in Turborepo 1.5."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"globalEnv\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"$MY_ENV_VAR\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["上面声明的环境变量带有 ", _jsx(_components.code, {
        children: "$"
      }), " 前缀。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The environment variable declared above has the ", _jsx(_components.code, {
        children: "$"
      }), " prefix."]
    }), "\n", _jsx(_components.h2, {
      id: "解决方案-solution",
      children: "解决方案 "
    }), "\n", _jsx(_components.p, {
      children: "¥Solution"
    }), "\n", _jsxs(_components.p, {
      children: ["从环境变量声明中删除 ", _jsx(_components.code, {
        children: "$"
      }), " 前缀。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Remove the ", _jsx(_components.code, {
        children: "$"
      }), " prefix from your environment variable declaration."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"globalEnv\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"MY_ENV_VAR\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["你可以使用 ", _jsx(_components.code, {
        children: "npx @turbo/codemod migrate-env-var-dependencies"
      }), " 迁移到 ", _jsx(_components.code, {
        children: "env"
      }), " 和 ", _jsx(_components.code, {
        children: "globalEnv"
      }), " 键。签出 ", _jsx(_components.a, {
        href: "/docs/reference/turbo-codemod#turborepo-1x",
        children: "codemod 文档（更多详情）"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥You can migrate to the ", _jsx(_components.code, {
        children: "env"
      }), " and ", _jsx(_components.code, {
        children: "globalEnv"
      }), " keys using ", _jsx(_components.code, {
        children: "npx @turbo/codemod migrate-env-var-dependencies"
      }), ".\nCheck out ", _jsx(_components.a, {
        href: "/docs/reference/turbo-codemod#turborepo-1x",
        children: "the codemod's documentation for more details"
      }), "."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
